<template>
  <div class="container">
    <blog-header :heading-text="page.title" :html-string="page.template.introductie || ''"/>
    <section>
      <filter-bar
        v-model="filters"
        :selected-layout="selectedLayout"
        @layout-changed="changeLayout"
      />
    </section>
    <section v-if="!$apollo.loading" class="flex flex-wrap justify-between">
      <header class="w-full h2 text-secondary pb-8">Resultaten</header>
      <div v-show="selectedLayout === 'Grid'" class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        <div v-if="!begeleiders || !begeleiders.data.length">Geen resultaten gevonden</div>
        <mentor-item v-for="begeleider in begeleiders.data" :key="begeleider.name" :mentor="begeleider"/>
      </div>
      <div v-show="selectedLayout === 'Kaart'" class="w-full">
        <google-maps :begeleiders="begeleiders.data"/>
      </div>
      <pagination v-if="selectedLayout !== 'Kaart' && begeleiders.data.length" v-model="p" :last-page="begeleiders.last_page" :current-page="p"/>
    </section>
  </div>
</template>

<script>
import MentorItem from '~/components/begeleiders/MentorItem';
import FilterBar from '~/components/begeleiders/FilterBar';
import begeleiders from '~/graphql/queries/begeleiders';
import pagination from '~/components/base/Pagination';
import GoogleMaps from '~/components/begeleiders/GoogleMaps';
import BlogHeader from '~/components/fullwidth-blocks/BlogHeader';
import page from '~/plugins/mixins/page';

export default {
  layout: 'blog',
  components: {BlogHeader, FilterBar, MentorItem, pagination, GoogleMaps},
  mixins: [page],
  data: () => ({
    p: 1,
    limit: 999,
    filters: {},
    doelgroep: null,
    kwalificaties: null,
    locatie: null,
    bereik: null,
    selectedLayout: 'Kaart',
    begeleiders: {data: []},
  }),
  apollo: {
    begeleiders: {
      query: begeleiders,
      variables() {
        return {
          page: this.p,
          limit: this.limit,
          doelgroep: this.doelgroep,
          kwalificaties: this.kwalificaties,
          locatie: this.locatie,
          bereik: this.bereik,
        };
      },
      update(data) {
        return {data: data.begeleiders.data.filter(b => this.selectedLayout === 'Kaart' ? b.latitude !== 0 && b.longitude !== 0 : true)};
      },
      fetchPolicy: 'network-only',
    },
  },
  watch: {
    selectedLayout(layout) {
      this.limit = layout === 'Grid' ? 6 : 999;
      this.p = 1;
    },
    filters: {
      deep: true,
      handler() {
        this.setDoelgroep();
        this.setKwalificaties();
        this.setProximity();
      },
    },
  },
  methods: {
    setDoelgroep() {
      if (!this.filters.doelgroep) {
        this.doelgroep = null;
      } else {
        this.doelgroep = this.filters.doelgroep.id;
      }
    },
    setKwalificaties() {
      if (!this.filters.kwalificaties) {
        this.kwalificaties = null;
      } else {
        this.kwalificaties = this.filters.kwalificaties.map(kwalificatie => parseInt(kwalificatie.id));
      }
    },
    setProximity() {
      if (!this.filters.locatie || !this.filters.bereik) {
        this.locatie = null;
        this.bereik = null;
      } else {
        this.locatie = this.filters.locatie;
        this.bereik = this.filters.bereik.value;
      }
    },
    changeLayout(val) {
      this.selectedLayout = val;
      if (val === 'Kaart') {
        this.page = 1;
        this.limit = 100;
      }
    },
  },
};
</script>
